import React from 'react'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import Header from './components/Header/index.js'
import Footer from './components/Footer/index.js'
import Home from './components/Home/index.js'
import About from './components/About/index.js'
import Async from 'react-code-splitting'
import Help from './components/Help/index.js'
import SelfHelp from './components/Help/selfHelp.js'
import OthersHelp from './components/Help/othersHelp.js'
import Liability from './components/Liability/'
import Youth from './components/Youth'
import Teacher from './components/Teacher'
const Admin = () => <Async load={import('./components/Admin/')} />



class Routes extends React.Component {
    render() {
      let router =
        <div>
          <Header logoUrl={'/img/mindAidlogo.png'} fluid={true} />
            <Liability />
          <Switch>
          <Route exact path="/" component={Home} />
          <Route path='/about' component={About} />
          <Route path='/teacher' component = {Teacher}/>
          <Route path='/youth' component = {Youth}/>
          <Route path='/admin' component={Admin}/>
          <Route path='/help' component={Help} />
          <Route path='/self-help' component={SelfHelp} />
          <Route path='/help-from-others' component={OthersHelp} />
          <Route render={() => {
            return(
              <h2 style={{"textAlign": "center", "padding": "30px"}}>Page Not Found</h2>
            )

          }} />

        </Switch>

        </div>
      let footer = ( <Footer logoUrl={'/img/mindAidlogo.png'} />);
      return (
        <div className="app">
          <div className="content">

        <Router {...this.props}>
          <div>
            <div  className="container">
              {router}
            </div>
            {footer}
          </div>
        </Router>
        </div>
        </div>
      )
    }

}



export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js